import { render, staticRenderFns } from "./ParentCarers.vue?vue&type=template&id=4c5ec4a2&"
import script from "./ParentCarers.vue?vue&type=script&lang=js&"
export * from "./ParentCarers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports